<template>
    <div class="mb-4">
        <div
            class="flex flex-col md:flex-row md:items-center"
            :class="alignCenter&&'md:justify-end'"
        >
            <slot name="label">
                <p
                    class="text-lg mr-2 my-1 flex-shrink-0"
                    :class="labelColor?labelColor:'text-gray-900'"
                >
                    {{ label }}
                </p>
            </slot>

            <div
                class="text-lg text-gray-700 md::w-[18.75rem] w-full md:max-w-[18.75rem] items-center flex-shrink-0 relative"
            >
                <slot name="input">
                    <template v-if="type===TypeList[0]">
                        <span>{{ inputValue }}</span>
                    </template>
                    <template v-if="type===TypeList[1]||type===TypeList[2]">
                        <input
                            v-model="inputValue"
                            class="input-base "
                            :class="inputClass?inputClass:''"
                            autocomplete="off"
                            :inputmode="inputmode"
                            :maxlength="maxlength"
                            :type="(type==='text'||isEyeOpen)?'text':'password'"
                            :placeholder="placeholder"
                            :disabled="disabled"
                            @input="emitValue"
                        >
                        <SvgIcon
                            v-if="type==='password'"
                            :icon-name="isEyeOpen?'eye':'eye-off'"
                            class="text-gray-700 w-6 h-6 cursor-pointer absolute right-3 top-3"
                            @click="isEyeOpen=!isEyeOpen"
                        />
                    </template>
                </slot>
            </div>
            <slot name="button" />
        </div>
        <div class="flex flex-col md:flex-row md:justify-end md:items-center ">
            <span class="md::w-[18.75rem] w-full md:max-w-[18.75rem] text-error text-sm">{{ errorMsg }}</span>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue';

const TypeList = [
    'wording', // 顯示純文字;
    'text', // input輸入;
    'password', // 密碼輸入
];

export default {
    props: {
        // 靠中間嗎？中間：左邊
        alignCenter: {
            type: Boolean,
            default: true,
        },
        // 標籤
        label: {
            type: String,
            default: '',
        },
        // 標籤顏色客製化
        labelColor: {
            type: String,
            default: '',
        },
        // 欄位值
        value: {
            type: String,
            default: '',
        },
        // 錯誤訊息
        errorMsg: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        inputmode: {
            type: String,
            default: 'email',
        },
        type: {
            validator: value => !!(TypeList.find(i => i === value)),
            default: () => 'text',
        },
        maxlength: {
            type: Number,
            default: 30,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: String,
            default: '',
        },
    },
    emits: ['update:value', 'validateValue'],
    setup(props, { emit }) {
        const inputValue = ref(props.value);
        const isEyeOpen = ref(false);

        const emitValue = (e) => {
            emit('update:value', e.target.value);
            emit('validateValue', e.target.value);
        };

        watch(() => props.value, (nV) => {
            inputValue.value = nV;
        });
        return {
            inputValue,
            TypeList,
            isEyeOpen,
            emitValue,
        };
    },

};
</script>

<style lang="scss" scoped>
.placeholder-text-xs {
    &::placeholder {
        @apply text-xs
    }
}
.placeholder-text-black {
    &::placeholder {
        @apply text-black
    }
}
</style>
